// @flow
import {
    createStore as reduxCreateStore,
    applyMiddleware,
    combineReducers,
    compose
} from 'redux';
import thunk from 'redux-thunk';
import Reducers from './reducers';
import {middlewareAdapter} from '@homeaway/redux-middleware-adapter';
import registerAllMiddleware from './middleware/all';
import {pruneItem, getJSONItem} from './utils/localStorageWrapper';
import {connectRouter, routerMiddleware} from 'connected-react-router';
import type {Store} from './reducers';

/**
 * Initialize the redux store.
 *   - connects middleware and reducers
 *   - configures the chrome extension for redux
 */
function createStore({
    initialState,
    history
}: {
    initialState: any,
    history: any
}): Store {
    // Each middleware function is registered with the middlewareAdapter and
    // is assigned an action to respond to. See './middleware/all'
    registerAllMiddleware();

    // setup
    const reducers = {
        ...Reducers,
        router: connectRouter(history)
    };
    const composeEnhancers =
        (typeof window !== 'undefined' &&
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
        compose;
    const middleware = [middlewareAdapter, thunk, routerMiddleware(history)];

    if (typeof window !== 'undefined') {
        // Add LocalStorage specific state
        pruneItem({itemKey: 'serpMapMarkers'});
        initialState.map.mapMarkersClicked =
            getJSONItem({itemKey: 'serpMapMarkers'}) || {};
    }

    // create middleware
    const createStoreWithMiddleware = composeEnhancers(
        applyMiddleware(...middleware)
    )(reduxCreateStore);

    const rootReducer = combineReducers(reducers);
    // Merge the initial and updated router state using the browser's history.
    const initialStateWithUpdatedHistory = {
        ...initialState,
        router: {...history}
    };
    const store = createStoreWithMiddleware(
        rootReducer,
        initialStateWithUpdatedHistory
    );

    // Enable Webpack hot module replacement for reducers
    if (module.hot) {
        module.hot.accept('./reducers/index', () => {
            // $FlowFixMe!
            store.replaceReducer(Reducers);
        });
    }
    return store;
}
export {createStore};
